import { FeedStockTradingStatus, PlanningAndSchedulingStatus, ProcessEngineeringStatus } from "../domains/DepartmentEvaluation/RequirementStatus";

export const CATEGORIES = new Map([
  ["quality_deviation", "Quality Deviation"],
  ["opportunities", "Opportunities"],
  ["business_development", "Business Development"],
  ["safety_of_supply", "Safety Supply"],
  ["quality_report", "Vessel Quality Report"],
]);

export const ACCEPTED_FILES_FORMAT = [
  "application/pdf",
  "application/vnd.ms-excel",
  "application/vnd.ms-outlook",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.rar",
  "application/zip",
  "message/rfc822",
  "application/octet-stream",
  ".msg"
];

export const ACCEPTED_FILES_EXTENSIONS = [
  ".pdf",
  ".xls",
  ".xlxs",
  ".doc",
  ".docx",
  ".rar",
  ".zip",
  ".msg",
  ".eml",
];

export const CLUSTER_GRAPHICS_REQUIRED_COMPONENTS = [
  "n-Paraffins (n-P)",
  "iso-Paraffins (i-P)",
  "Naphthenes (N)",
  "Aromatics (A)",
  "Density 20/4 ºC",
  "Initial Boiling Point (IBP)",
  "Distillation 50%",
  "Final Boiling Point (FBP)",
];

export const HARD_CODED_UNITS = [
  "ppb_wt",
  "ppm_wt",
  "ºC",
  "K",
  "ºF",
  "%_wt",
  "%_vol",
  "g/cm3",
  "psi",
  "bar",
  "Pa",
];

export const HARD_CODED_PIONA_UNITS = ["%_wt", "%_vol"];

export const DEPARTMENTS = new Map([
  ["planning_and_scheduling", "Planning and Scheduling"],
  ["process_engineering", "Process Engineering"],
  ["feedstock_trading", "Feedstock Trading"],
]);

export const requirementStatusForProcessEngineering = [ "process_evaluation" ];

export const requirementStatusForPlanningAndScheduling = ["planning_evaluation", "technical_approved", "technical_approved_with_restrictions", "technical_rejected", "missing_information"];

export const requirementStatusForFeedstockTrading = ["request_extra_information"];

export const DEPARMENT_STATUS_FILTER = (requirementStatus: ProcessEngineeringStatus | FeedStockTradingStatus | PlanningAndSchedulingStatus) => {
  if (requirementStatusForProcessEngineering.includes(requirementStatus)) {
    return "process_engineering";
  }

  if (requirementStatusForPlanningAndScheduling.includes(requirementStatus)) {
    return "planning_and_scheduling";
  }

  if (requirementStatusForFeedstockTrading.includes(requirementStatus)) {
    return "feedstock_trading";
  }
};